
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class InputText extends Vue {
  @Prop(String) public readonly label!: string;
  @Prop({ type: String, default: 'string' }) public readonly type!: string;
  @Prop(String) private readonly model!: string;
  @Prop(Boolean) public readonly disabled!: boolean;
  @Prop(String) public readonly icon!: string;
  @Prop(String) public readonly hint!: string;
  public input = '';
  public changeInput() {
    this.$emit('add', this.model, [this.input]);
    this.input = '';
  }
  public blur() {
    this.input = '';
  }
}
